export interface BaseUpdate<
  TValueData extends object,
  TValueType extends number
> {
  current: TValueData;
  new: TValueData;
  conflicts: TValueType;
  changes: TValueType;
  defaultOverwrites: TValueType | undefined;
}

export interface EditableBaseUpdate<
  TValueData extends object,
  TValueType extends number
> extends BaseUpdate<TValueData, TValueType> {
  /** bitfield of fields to overwrite in the event of conflicts */
  overwrites: TValueType;
}

export interface BaseValidateResponse<TDelta extends object> {
  success: boolean;
  message: string;
  saveImportId: string;
  expirationDate: string;
  delta: TDelta;
}

export interface SaveResponse {
  success: boolean;
  message: string | null;
  redirectUrl: string;
}
